import axios from 'axios'
import { IPatchModel } from 'shared/models/Common'
import {
  IBoardMeetingFilter,
  IBoardMeetingParticipant,
  ICreateBoardMeetingModel,
} from '../models/BoardMeeting'

const BASE_URL = 'boardmeetings/meetings'
const BASE_MEETING_CLIENTS_URL = 'boardmeetings/clients'
const defaultConfig = {
  headers: {
    'x-api-version': '1.0',
  },
}

export const getBoardmeetings = (body: IBoardMeetingFilter) =>
  axios.post(`${BASE_URL}/query`, body, {
    cancelToken: body.source?.token,
  })

export const getBoardMeeting = (id: string) =>
  axios.get(`${BASE_URL}/${id}`, defaultConfig)

export const patchBoardMeeting = (meetingId: string, models: IPatchModel[]) =>
  axios.patch(`${BASE_URL}/${meetingId}`, models, defaultConfig)

export const createBoardMeeting = (model: ICreateBoardMeetingModel) =>
  axios.post(`${BASE_URL}`, model, defaultConfig)

export const deleteBoardMeeting = (meetingId: string) =>
  axios.delete(`${BASE_URL}/${meetingId}`, defaultConfig)

export const getCase = (caseId: string) =>
  axios.get(`${BASE_URL}/cases/${caseId}`, defaultConfig)

export const startMeeting = (meetingId: string) =>
  axios.post(`${BASE_URL}/${meetingId}/ongoing`, defaultConfig)

export const cancelMeeting = (meetingId: string) =>
  axios.post(`${BASE_URL}/${meetingId}/cancelled`, defaultConfig)

export const changeSecretaryOnMeeting = (meetingId: string) =>
  axios.post(`${BASE_URL}/${meetingId}/editingUser`, defaultConfig)

export const getBoardmeetingsPeriods = (clientId: string) =>
  axios.get(
    `${BASE_MEETING_CLIENTS_URL}/${clientId}/boardperiods`,
    defaultConfig
  )

/*
 * Participants
 */
export const getMeetingParticipantsForEdit = (meetingId: string) =>
  axios.get(`${BASE_URL}/${meetingId}/participants/foredit`, defaultConfig)

export const getMeetingParticipants = (meetingId: string) =>
  axios.get(`${BASE_URL}/${meetingId}/participants`, defaultConfig)

export const patchMeetingParticipants = (
  meetingId: string,
  model: IPatchModel<IBoardMeetingParticipant[]>[]
) => axios.patch(`${BASE_URL}/${meetingId}/participants`, model, defaultConfig)

export const sendNoticeToParticipants = (meetingId: string, ids: string[]) =>
  axios.post(`${BASE_URL}/${meetingId}/emailnotification`, ids, defaultConfig)

export const sendNoticeToAllParticipants = (meetingId: string) =>
  axios.post(
    `${BASE_URL}/${meetingId}/emailnotification/all`,
    null,
    defaultConfig
  )
